import Reflux from 'reflux';
import LookupActions from '../actions/LookupActions';

export var LookupRefreshStore = Reflux.createStore(
{
	init:function(){this.listenTo(LookupActions.lookupRefresh,'lookupRefresh')},
    lookupRefresh(formId,innerId)
    {
		this.trigger(formId,innerId);
    }
});


export default LookupRefreshStore;


// WEBPACK FOOTER //
// ./src/stores/LookupRefreshStore.js